<div class="cds-flex cds-flex-col cds-w-full cds-h-full cds-gap-2">
  <h1 class="cds-font-desktop-headline-1-roman cds-text-desktop-headline-4-medium">QFA Tool</h1>
  <hr class="cds-w-full cds-h-[2px] cds-bg-[#afafaf] cds-my-5" />
  <div class="cds-flex cds-justify-between cds-items-center">
    <div class="cds-flex">
      <h2
        class="cds-font-desktop-headline-1-roman cds-text-desktop-headline-5-medium"
        [class]="{ '!cds-leading-6': sharedPolicyData?.warning }">
        Policy details
      </h2>
    </div>
    <div class="cds-flex cds-items-start cds-text-left cds-content-start">
      <span
        #progressMenu
        class="cds-text-right"
        cbDropdownMenu
        label=" "
        [displayOnClick]="true"
        colorway="light"
        labelIcon="utility-ellipses-vt">
        <p-tieredmenu
          #menu
          appendTo="body"
          [model]="menuList"
          [popup]="true"
          [autoZIndex]="false"
          data-testid="policy-details-menu">
          <ng-template #item let-item>
            <a pRipple class="flex !cds-text-nowrap !cds-justify-start !cds-gap-1 items-center p-tieredmenu-item-link">
              @if (item.label === 'Reset Quote') {
                <cb-icon iconKey="utility-refresh" iconSize="regular" iconColor="neutral-800" />
              } @else {
                <cb-icon iconKey="utility-trash-stroke" iconSize="regular" iconColor="error-shade" />
              }
              <span [class]="{ '!cds-text-error-shade': item.label.startsWith('Remove') }">{{ item.label }}</span>
            </a>
          </ng-template>
        </p-tieredmenu>
      </span>
    </div>
  </div>
  @if (sharedPolicyData?.warning) {
    <p class="body-small cds-italic cds-text-error-shade" data-testid="policy-details-warning">
      {{ sharedPolicyData?.warning }}
    </p>
  }
  <p data-testid="policy-details-number">
    <strong>Policy:</strong>
    {{ sharedPolicyData?.policy?.number }}
  </p>
  <p data-testid="policy-details-product">
    <strong>Product:</strong>
    {{ _baseGetValByCode('productCategory', sharedPolicyData?.policy?.productCategory) }}
  </p>
  <p data-testid="policy-details-fee">
    <strong>Policy Fee:</strong>
    ${{ (sharedPolicyData?.policy?.fee?.amount ?? 0) / 100 | number: '1.2-2' }}
  </p>
  @if (sharedPolicyData?.policy?.discounts !== null) {
    <p data-testid="policy-details-discount">
      <strong>Policy Discount:</strong>
      {{ _baseGetValByCode('policyDiscount', sharedPolicyData?.policy?.discounts) }}
    </p>
  }
  @if (sharedPolicyData?.policy?.comment !== null) {
    <p data-testid="policy-details-comment">
      <strong>Comments:</strong>
      {{ sharedPolicyData?.policy?.comment ?? 'No comments' }}
    </p>
  }
</div>
<div>
  <cb-modal
    [title]="'Reset Quote'"
    [open]="openResetQuoteConfirmation"
    customContent="true"
    [closeOnEscape]="false"
    [hideCloseIcon]="false"
    [hideDefaultFooter]="true"
    [actions]="modalActions"
    (closeEvent)="handleResetQuoteModal()"
    data-testid="policy-details-reset-quote-modal">
    <div>
      <p>
        Are you sure you would like to reset the page? This action will reset the page with the In Force Policy detail.
      </p>
    </div>
    <div class="cds-flex cds-justify-end cds-gap-3 cds-mt-8">
      <button
        cbButton
        label="No"
        variant="secondary"
        colorTheme="purple"
        data-testid="policy-details-reset-quote-modal-cancel-button"
        (click)="handleResetQuoteModal()"></button>
      <button
        cbButton
        label="Yes"
        variant="primary"
        colorTheme="purple"
        data-testid="policy-details-reset-quote-modal-reset-button"
        (click)="resetQuote()"></button>
    </div>
  </cb-modal>
</div>

@if (selectedCustomer) {
  <div>
    <cb-modal
      [title]="'Remove ' + (selectedCustomer.firstName || '') + ' ' + (selectedCustomer.lastName || '')"
      [open]="openRemoveCustomerConfirmation"
      customContent="true"
      [closeOnEscape]="false"
      [hideCloseIcon]="false"
      [hideDefaultFooter]="true"
      [actions]="modalActions"
      (closeEvent)="handleRemoveCustomerModal()"
      data-testid="policy-details-remove-customer-modal">
      <div>
        <!-- Show message based on removal status -->
        @if (removeStatus === removeCustomerStatusEnums.LAST_CUSTOMER) {
          <p>You cannot remove the last life insured from the policy.</p>
        }
        @if (removeStatus === removeCustomerStatusEnums.LAST_ADULT_WITH_CHILD_TRAUMA) {
          <p>Cannot remove the last adult as children with trauma covers depend on this adult.</p>
        }
        @if (removeStatus === removeCustomerStatusEnums.CUSTOMER_HAS_DEPENDENCIES) {
          <p>
            There is a child associate with this cover and the child's cover will be removed if the Life Insured is
            removed.
          </p>
        }
        @if (removeStatus === removeCustomerStatusEnums.ALLOWED) {
          <p>Are you sure you want to remove {{ selectedCustomer.firstName }} {{ selectedCustomer.lastName }}?</p>
        }
      </div>
      <div class="cds-flex cds-gap-3 cds-justify-end cds-mt-6">
        <button
          cbButton
          label="Cancel"
          variant="secondary"
          colorTheme="purple"
          data-testid="policy-details-remove-customer-modal-cancel-button"
          (click)="closeRemoveCustomerDialog()"></button>
        <button
          cbButton
          label="Remove"
          variant="primary"
          colorTheme="purple"
          data-testid="policy-details-remove-customer-modal-remove-button"
          (click)="removeCustomer()"
          [disabled]="disableModalRemove"></button>
      </div>
    </cb-modal>
  </div>
}
